import { Box, Button, ButtonProps, Text } from '@chakra-ui/react';
import React, { FC } from 'react';

interface Props extends ButtonProps {
  disabled?: boolean;
  onClick: () => void;
  label: string;
  isActive: boolean;
  sub?: string;
}

export const ViewSelectorButton: FC<Props> = ({
  disabled,
  isActive,
  onClick,
  label,
  sub,
  ...rest
}) => {
  return (
    <Button
      w="100%"
      isDisabled={disabled}
      bg={isActive ? 'orange' : 'neutral.1000'}
      py="10px"
      px="20px"
      borderRadius="12px"
      onClick={onClick}
      color={isActive ? 'white' : 'gray.4'}
      transition="all 0.2s ease"
      {...rest}
    >
      <Box position="relative">
        <Text
          fontSize="16px"
          fontFamily="'Inter', sans-serif"
          fontWeight="500"
          lineHeight="20px"
          position="relative"
        >
          {label}
        </Text>
        {sub && (
          <Text
            fontSize="12px"
            position="absolute"
            px="4px"
            sx={{ top: '-4px', left: '100%' }}
          >
            {sub}
          </Text>
        )}
      </Box>
    </Button>
  );
};
